import { useQuery, gql } from "@apollo/client"
import { SENSOR_RULE_FIELDS } from "./fragments/sensorRuleFieldsFragment"

const SENSOR_RULE_QUERY = gql`
  query SensorRules($sensor: ID!) {
    sensor(id: $sensor) {
      rules {
        list {
          ...SensorRuleFields
        }
      }
    }
  }
  ${SENSOR_RULE_FIELDS}
`

const sensorRuleTypePolicies = {
  root: {},
  scoped: {
    SensorRule: {
      fields: {
        notifications: {
          merge(_, incoming) {
            return incoming
          }
        }
      }
    }
  }
}

const useQuerySensorRules = (options) => useQuery(SENSOR_RULE_QUERY, options)

export { useQuerySensorRules, sensorRuleTypePolicies }
